import React from 'react';
import { withRouter } from 'react-router-dom';
import IconButton from '../common/icon-button';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { toggleTag } from '../../reducers/booklet-tags.reducer';
import { types } from '../../consts';
import { Link } from 'react-router-dom';
import styles from './menu.module.css';
import logoImage from '../../assets/images/papaya_profile_pic_logo.png';
import Icon from '../../assets/icons/Icon';

const MOBILE_L_SCREEN_SIZE = 768;

const menuCenterItems = [
  {
    url: '/decks',
    label: 'Decks',
    type: null,
  },
  {
    url: '/creators',
    label: 'Creators',
    type: null,
  },
  {
    url: '/locations',
    label: 'Locations',
    type: types.LOCATION,
  },
  {
    url: '/talents',
    label: 'Talents',
    type: types.ACTOR,
  },
  {
    url: '/',
    label: 'Booklets',
    type: types.BOOKLET,
  },
  {
    url: '/users',
    label: 'Users',
    type: types.USER,
    adminOnly: true,
  },
  {
    url: '/archive',
    label: 'Archive',
    type: types.ARCHIVE,
  },
];

const menuRightItem = {
  url: '/logout',
  label: 'Logout',
  type: null,
};

class MainMenu extends React.Component {
  state = {
    mq: {},
    anchorEl: null,
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const mq = window.matchMedia(`(min-width: ${MOBILE_L_SCREEN_SIZE}px)`);
    this.setState({ mq });
  };

  handleMenuClick = type => {
    const { dispatch } = this.props;
    dispatch(toggleTag(null, type));
  };

  getAuthorizedMenuItems = (item, index, isAdmin) => {
    if (item.adminOnly) {
      return isAdmin;
    }
    return true;
  };

  getLogo = () => (
    <div ref="logo" className={styles.appLogo}>
      <img src={logoImage} alt={'iBooklet 2.0'} />
    </div>
  );

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  renderToggleMenu = isAdmin => {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    return (
      <div>
        <IconButton tooltip="Show more" onClick={this.handleClick}>
          <Icon name="overflow" />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={() => this.handleClose()}
        >
          {[...menuCenterItems, menuRightItem]
            .filter((item, index) =>
              this.getAuthorizedMenuItems(item, index, isAdmin)
            )
            .map(item => {
              return (
                <MenuItem key={item.label} onClick={() => this.handleClose()}>
                  <Link to={item.url} className={styles.menuItem}>
                    {item.label}
                  </Link>
                </MenuItem>
              );
            })}
        </Menu>
      </div>
    );
  };

  getLocation = url => {
    const fullPath = this.props.history.location.pathname;
    const location = fullPath.split('/')[1];

    if (url === '/' && (location === 'booklet' || location === '')) {
      return true;
    } else if (location && url.includes(location)) {
      return true;
    }

    return false;
  };

  render() {
    const { isAdmin, user } = this.props;
    const { mq } = this.state;

    return (
      <div className={styles.appMenu}>
        {mq.matches
          ? user && (
              <div className={styles.innerWrapper}>
                <div>{this.getLogo()}</div>
                <div className={styles.centerMenu}>
                  {menuCenterItems
                    .filter((item, index) =>
                      this.getAuthorizedMenuItems(item, index, isAdmin)
                    )
                    .map((item, index) => {
                      return (
                        <Link
                          className={`${styles.menuItem} ${this.getLocation(
                            item.url
                          ) && styles.active}`}
                          key={index}
                          to={item.url}
                          onClick={() => this.handleMenuClick(item.type)}
                        >
                          <div className={styles.menuItem}>{item.label}</div>
                        </Link>
                      );
                    })}
                </div>
                <div>
                  <Link
                    className={styles.menuItem}
                    to={menuRightItem.url}
                    onClick={() => this.handleMenuClick(menuRightItem.type)}
                  >
                    <div className={styles.menuItem}>{menuRightItem.label}</div>
                  </Link>
                </div>
              </div>
            )
          : this.renderToggleMenu(isAdmin)}
      </div>
    );
  }
}

export default withRouter(MainMenu);



// WEBPACK FOOTER //
// ./src/components/menu/menu.js